class FrequentlyBoughtTogether {
  constructor() {
    this.container = document.querySelector('.fbt');

    if (!this.container) return;

    this.cards = [...this.container.querySelectorAll('.fbt-card')];
    this.checkboxes = this.container.querySelectorAll('.fbt-checkbox');

    this.totalPrice = this.container.querySelector('.fbt-total-price');
    this.totalCompare = this.container.querySelector('.fbt-total-compare');
    this.bundleButton = this.container.querySelector('.fbt-add-all');
    this.bundleCount = this.container.querySelector('.fbt-selected-count');

    this.bindCheckboxes();
    this.bindProductButtons();
    this.bindBundleButton();

    this.updateTotals();
  }

  bindCheckboxes() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.updateTotals());
    });
  }

  bindProductButtons() {
    this.container.querySelectorAll('.fbt-card__button').forEach((button) => {
      button.addEventListener('click', async () => {
        const card = button.closest('.fbt-card');

        await this.addLines([
          {
            merchandiseId: card.dataset.variantId,
            quantity: 1
          }
        ], button, 'Add to Cart');
      });
    });
  }

  bindBundleButton() {
    if (!this.bundleButton) return;

    this.bundleButton.addEventListener('click', async () => {
      const lines = [];

      this.cards.forEach((card) => {
        const checkbox = card.querySelector('.fbt-checkbox');

        if (!checkbox.checked) return;

        lines.push({
          merchandiseId: card.dataset.variantId,
          quantity: 1
        });
      });

      if (!lines.length) return;

      await this.addLines(lines, this.bundleButton, 'Add All to Cart');
    });
  }

  async addLines(lines, button, defaultText) {
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const result = await Shopify.actions.updateCart({ lines });

      if (result.userErrors?.length) {
        throw new Error(result.userErrors[0].message);
      }

      Shopify.actions.openCart();

      button.textContent = 'Added ✓';
    } catch (error) {
      console.error(error);
      button.textContent = 'Error';
    }

    setTimeout(() => {
      button.disabled = false;
      button.textContent = defaultText;
    }, 1500);
  }

  updateTotals() {
    let totalPrice = 0;
    let totalComparePrice = 0;
    let selectedCount = 0;

    this.cards.forEach((card) => {
      const checkbox = card.querySelector('.fbt-checkbox');

      if (!checkbox.checked) return;

      selectedCount++;

      totalPrice += Number(card.dataset.price);
      totalComparePrice += Number(card.dataset.comparePrice || 0);
    });

    this.totalPrice.textContent = `Rs. ${(totalPrice / 100).toLocaleString('en-PK')}`;

    this.totalCompare.textContent =
      totalComparePrice > totalPrice
        ? `Rs. ${(totalComparePrice / 100).toLocaleString('en-PK')}`
        : '';

    if (this.bundleCount) {
      this.bundleCount.textContent = selectedCount;
    }
  }
}

new FrequentlyBoughtTogether();